import { Store } from 'redux';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function authListener(_store: Store): void {
    // eslint-disable-next-line no-console
    console.info('authListener');
}
